import React, { useEffect, useState } from "react";
import { Form, Input, DatePicker, Select, Upload, Button, message, Table, Modal, Tooltip, Drawer } from "antd";
import { UploadOutlined, DownloadOutlined, SearchOutlined, EditOutlined, DeleteOutlined, CloseOutlined } from "@ant-design/icons";
import jsPDF from "jspdf";
import "jspdf-autotable";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import axios from "axios";
import Sidebar from "../Components/SideBar";
import { buildApiUrl } from "../utils/api";

dayjs.extend(isBetween);

const { Option } = Select;
const { TextArea } = Input;

const DailyLog = () => {
    const [form] = Form.useForm();
    const [logs, setLogs] = useState([]);
    const [filteredLogs, setFilteredLogs] = useState();
    const [filters, setFilters] = useState({ dateRange: null, personnel: null, project: null, keyword: "" });
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editingLog, setEditingLog] = useState(null);
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [logToDelete, setLogToDelete] = useState(null);
    const userRole = localStorage.getItem("role");
    const [isViewModalVisible, setIsViewModalVisible] = useState(false);
    const [viewingLog, setViewingLog] = useState(null);
    const [isModal, setIsModal] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [lastRefreshed, setLastRefreshed] = useState("");

    const [users, setUsers] = useState([]);
    const [projects, setProjects] = useState([]);
    const [dailyLogs, setDailyLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const token = localStorage.getItem("token");
    const [selectedUser, setSelectedUser] = useState(null);


    useEffect(() => {
        const now = new Date();
        const formatted = dayjs(now).format("DD MMM YYYY, hh:mm A");
        setLastRefreshed(formatted);
    }, []);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await axios.get(
                    buildApiUrl('/api/daily-logs/users'),
                    {
                        headers: {
                            "Authorization": `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                setUsers(response.data.users);
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };
        fetchUsers();
    }, [token]);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const response = await fetch(
                    buildApiUrl('/api/daily-logs/projects'),
                    {
                        method: "GET",
                        headers: {
                            "Authorization": `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                const data = await response.json();
                if (data.projects) {
                    setProjects(data.projects);
                }
            } catch (error) {
                console.error("Error fetching projects:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchProjects();
    }, [token]);


    const fetchLogs = async () => {
        try {
            const response = await fetch(buildApiUrl('/api/daily-logs'), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }
            });
            const data = await response.json();
            if (data.message === 'DailyLogs retrieved successfully') {
                const logs = data.dailyLogs.map(log => {
                    return {
                        key: log._id,
                        date: log.date,
                        personnel: log.personnel.length > 0
                            ? log.personnel.map(p => p.username)
                            : [],

                        project: log.project.length > 0
                            ? log.project.map(p => p.projectName)
                            : [],
                        description: log.logDescription,
                        attachments: log.attachments,
                    };
                });

                // Sort logs by date in descending order
                logs.sort((a, b) => dayjs(b.date, "DD-MM-YYYY").unix() - dayjs(a.date, "DD-MM-YYYY").unix());

                setLogs(logs);
                setDailyLogs(logs);
                setFilteredLogs(logs); // Initially show all logs
            }
        } catch (error) {
            console.error('Error fetching daily logs:', error);
        }
    };

    useEffect(() => {
        fetchLogs();
    }, [token]);



    console.log("DailyLogs :", dailyLogs)





    const applyFilters = () => {
        let filtered = dailyLogs;

        if (filters.startDate && filters.endDate) {
            const startDate = dayjs(filters.startDate, "DD-MM-YYYY").startOf("day");
            const endDate = dayjs(filters.endDate, "DD-MM-YYYY").endOf("day");
            filtered = filtered.filter((log) => {
                const logDate = dayjs(log.date, "DD-MM-YYYY");
                return logDate.isBetween(startDate, endDate, "day", "[]"); // Inclusive range
            });
        }

        if (filters.personnel) {
            filtered = filtered.filter(log => log.personnel.includes(filters.personnel));
        }

        if (filters.project) {
            filtered = filtered.filter(log => log.project.includes(filters.project));
        }

        if (filters.keyword) {
            filtered = filtered.filter(log =>
                log.description.toLowerCase().includes(filters.keyword.toLowerCase())
            );
        }

        setFilteredLogs(filtered);
    };

    useEffect(() => {
        applyFilters();
    }, [filters]);



    const handleFilterChange = (key, value) => {
        setFilters(prev => {
            const newFilters = { ...prev, [key]: value ?? null };
            applyFilters(newFilters);
            return newFilters;
        });
    };


    const [uploadedFiles, setUploadedFiles] = useState([]);

    const handleFileChange = ({ fileList }) => {
        setUploadedFiles(fileList);
    };

    useEffect(() => {
        if (editingLog && editingLog.attachments) {
            console.log('editingLog:', editingLog);
            console.log('editingLog.attachments:', editingLog.attachments);

            const formattedAttachments = editingLog.attachments.map((file, index) => {
                console.log('Processing file:', file);
                return {
                    uid: file._id,
                    name: file.public_id || `attachment-${index}`,
                    url: file.imageUrl,
                    status: "done",
                };
            });

            console.log('formattedAttachments:', formattedAttachments);
            setUploadedFiles(formattedAttachments);
        } else {
            console.log('No editingLog or attachments found.');
        }
    }, [editingLog]);








    const handleSubmit = async (values) => {
        const personnelIds = values.personnel.map(username => {
            const matchedUser = users.find(user => user.username === username);
            return matchedUser ? matchedUser._id : username;
        });
        console.log("projects", values)
        const projectIds = values.project.map(projectName => {
            const matchedProject = projects.find(project => project.projectName === projectName);
            return matchedProject ? matchedProject._id : projectName;
        });
        setSubmitLoading(true);

        const formData = new FormData();
        formData.append("date", dayjs(values.date).format("DD-MM-YYYY"));
        formData.append("personnel", JSON.stringify(personnelIds));
        formData.append("project", JSON.stringify(projectIds));
        formData.append("logDescription", values.description);


        if (values.attachments?.fileList && Array.isArray(values.attachments.fileList)) {
            values.attachments.fileList.forEach((file) => {
                if (file.originFileObj) {
                    formData.append("attachments", file.originFileObj, file.name);
                }
            });
        }

        try {
            const token = localStorage.getItem("token");
            const response = await fetch(buildApiUrl('/api/daily-logs'), {
                method: "POST",
                headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
                body: formData,
            });

            const data = await response.json();

            if (!response.ok) throw new Error(data.message || "Failed to create log.");

            message.success("Log added successfully!");
            await fetchLogs();

            setIsModalVisible(false);
            form.resetFields();
            setEditingLog(null);
        } catch (error) {
            console.error("Error creating log:", error);
            message.error(error.message || "Something went wrong.");
        } finally {
            setSubmitLoading(false);
        }
    };






    const handleEdit = async (values) => {
        const personnelIds = values.personnel.map(username => {
            const matchedUser = users.find(user => user.username === username);
            return matchedUser ? matchedUser._id : username;
        });


        const projectIds = [...new Set(values.project.map(projectName => {
            const matchedProject = projects.find(project => project.projectName === projectName);
            return matchedProject ? matchedProject._id : projectName;
        }))];
        setSubmitLoading(true);
        const formData = new FormData();


        formData.append("date", values.date.format("DD-MM-YYYY"));
        formData.append("personnel", Array.isArray(personnelIds) ? personnelIds : [personnelIds]);
        formData.append("project", projectIds);
        formData.append("logDescription", values.description);


        const retainedImageIds = uploadedFiles
            .filter(file => file.uid)
            .map(file => file.name);

        console.log("Retained Image IDs:", retainedImageIds);

        formData.append("retainedImageIds", retainedImageIds.join(","));

        values.attachments?.fileList?.forEach(file => {
            if (!file.url) {
                formData.append("attachments", file.originFileObj);
            }
        });

        try {
            const token = localStorage.getItem("token");
            const response = await fetch(buildApiUrl(`/api/daily-logs/${editingLog.key}`), {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
            });

            if (!response.ok) throw new Error("Failed to update log");

            message.success("Log updated successfully!");
            setIsModalVisible(false);
            setEditingLog(null);
            form.resetFields();
            fetchLogs();

        } catch (error) {
            console.error("Update error:", error);
            message.error("Failed to update log.");
        }
        finally {
            setSubmitLoading(false);
        }
    };






    const handleView = (log) => {
        setViewingLog(log);
        form.setFieldsValue({
            date: dayjs(log.date),
            personnel: log.personnel,
            project: log.project,
            description: log.description,
        });
        setIsViewModalVisible(true);
    };


    const handleDelete = async () => {
        if (!logToDelete) return;

        setDeleteLoading(true);
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(
                buildApiUrl(`/api/daily-logs/${logToDelete.key}`),
                {
                    method: "DELETE",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Failed to delete log");
            }


            setLogs((prevLogs) => prevLogs.filter((log) => log.id !== logToDelete.id));
            setFilteredLogs((prevLogs) => prevLogs.filter((log) => log.id !== logToDelete.id));

            message.success("Log deleted successfully!");
            fetchLogs();
            setIsDeleteModalVisible(false);
        } catch (error) {
            console.error("Error deleting log:", error);
            message.error(error.message || "Something went wrong!");
        }
        finally {
            setDeleteLoading(false);
        }
    };


    const generatePDF = async (log) => {
        console.log("log", log);


        const doc = new jsPDF();
        doc.setFontSize(14);
        doc.text("Daily Log Report", 20, 20);

        doc.setFontSize(10);
        doc.text(`Date: ${log.date}`, 20, 30);
        doc.text(`Personnel: ${log.personnel}`, 20, 40);
        doc.text(`Project: ${log.project}`, 20, 50);
        doc.text("Log Description:", 20, 60);
        doc.text(log.description, 20, 70, { maxWidth: 170 });


        let yPos = 90;
        if (log.attachments && log.attachments.length > 0) {
            doc.text("Attachments:", 20, yPos);
            yPos += 10;

            for (const file of log.attachments) {
                if (file.imageUrl && file.imageUrl.endsWith(".png")) {

                    const img = new Image();
                    img.src = file.imageUrl;

                    img.onload = () => {

                        doc.addImage(img, "PNG", 20, yPos, 50, 30);
                        yPos += 35;
                        if (log.attachments.indexOf(file) === log.attachments.length - 1) {
                            doc.save(`DailyLog_${log.date}.pdf`);
                        }
                    };
                } else {
                    doc.text(file.public_id, 30, yPos);
                    yPos += 10;
                }
            }
        } else {
            doc.text("No attachments available", 20, yPos);
        }


        if (log.attachments && log.attachments.every((file) => !file.imageUrl)) {

            doc.save(`DailyLog_${log.date}.pdf`);
        }
    };

    const handleRowClick = (record) => {
        if (userRole === 'admin') {
            handleView(record);
        } else {
        }
    };

    console.log("editinglog", editingLog)

    const handleDownloadPDF = async () => {
        if (!selectedUser) {
            message.error("Please select a user!");
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(
                buildApiUrl(`/api/daily-logs/user/${selectedUser}`),
                {
                    method: "GET",
                    headers: {
                        "Accept": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (!response.ok) throw new Error("Failed to fetch logs");

            const data = await response.json();
            if (!data.dailyLogs || data.dailyLogs.length === 0) {
                message.warning("No logs found for this user.");
                setLoading(false);
                return;
            }

            // Generate the PDF content
            const pdfDoc = await generatePDFContent(data.dailyLogs);

            // Download the PDF
            const username = data?.dailyLogs[0].personnel.username || "Unknown User";
            downloadPDF(pdfDoc, `Daily_Logs_of_${username}.pdf`);

            message.success("PDF downloaded successfully!");
        } catch (error) {
            console.error("Error downloading PDF:", error);
            message.error("Failed to download PDF.");
        } finally {
            setLoading(false);
        }
    };

    const generatePDFContent = async (logs) => {
        const doc = new jsPDF();


        const username = logs[0]?.personnel.username || "Unknown User";


        doc.setFontSize(18);
        const title = `Daily Logs Report of ${username}`;
        const titleWidth = doc.getTextWidth(title);
        const pageWidth = doc.internal.pageSize.width;
        const titleX = (pageWidth - titleWidth) / 2;

        doc.text(title, titleX, 20);

        let yPos = 30;

        for (let index = 0; index < logs.length; index++) {
            const log = logs[index];

            // Add log number
            doc.setFontSize(12);
            doc.text(`Daily Log ${index + 1}:`, 20, yPos);
            yPos += 10;

            // Add log details
            doc.text(`Date: ${dayjs(log.date).format("DD-MM-YYYY")}`, 20, yPos);
            yPos += 10;
            doc.text(`Personnel: ${log.personnel.username}`, 20, yPos);
            yPos += 10;
            doc.text(`Project: ${log.project.projectName}`, 20, yPos);
            yPos += 10;
            doc.text(`Description: ${log.logDescription}`, 20, yPos);
            yPos += 10;

            // Add attachments (image links)
            if (log.attachments && log.attachments.length > 0) {
                doc.text("Attachments:", 20, yPos);
                yPos += 10;

                let imgCounter = 0;
                for (let file of log.attachments) {
                    if (file.imageUrl && file.imageUrl.endsWith(".png")) {
                        imgCounter++;
                        doc.setTextColor(0, 0, 255); // Set text color to blue
                        doc.setFontSize(10); // Set font size for links


                        const linkText = `View ${imgCounter}`;
                        doc.textWithLink(linkText, 30, yPos, { url: file.imageUrl });
                        yPos += 10;
                    } else {
                        const displayText = `View File: ${file.public_id}`;
                        doc.setTextColor(0, 0, 255);
                        doc.setFontSize(10);
                        doc.textWithLink(displayText, 30, yPos, { url: file.public_id });
                        yPos += 10;
                    }
                }


                doc.setTextColor(0, 0, 0);
                doc.setFontSize(12);
            } else {
                doc.text("No attachments available", 20, yPos);
                yPos += 10;
            }


            yPos += 15;


            if (yPos > doc.internal.pageSize.height - 40) {
                doc.addPage();
                yPos = 20;
            }
        }

        return doc;
    };




    const downloadPDF = (doc, filename) => {
        doc.save(filename);
    };

    const columns = [
        {
            title: <span style={{ color: "#838383" }}>Date</span>,
            dataIndex: "date",
            key: "date",
            width: 120,
            render: (text) => text ? dayjs(text, "DD-MM-YYYY").format("DD-MM-YYYY") : "",
        },
        {
            title: <span style={{ color: "#838383" }}>Personnel</span>,
            dataIndex: "personnel",
            key: "personnel",
            width: 150,
            render: (personnel) => personnel ? personnel.join(", ") : "N/A",
        },
        {
            title: <span style={{ color: "#838383" }}>Project</span>,
            dataIndex: "project",
            key: "project",
            width: 180,
            render: (project) => project ? project.join(", ") : "N/A",
        },
        {
            title: <span style={{ color: "#838383" }}>Description</span>,
            dataIndex: "description",
            key: "description",
            ellipsis: true,
            width: 250,
        },
        {
            title: <span style={{ color: "#838383" }}>Actions</span>,
            key: "actions",
            fixed: "right",
            width: 160,
            render: (_, record) => (
                <div className="flex items-center gap-2">
                    {(userRole === "admin" || userRole === "user") && (
                        <Tooltip title="Update">
                            <Button
                                icon={<EditOutlined />}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setEditingLog(record);

                                    const processedAttachments = record.attachments?.map((attachment) => ({
                                        uid: attachment.public_id,
                                        name: attachment.name || "Attachment",
                                        status: "done",
                                        url: attachment.imageUrl,
                                        originFileObj: null,
                                    }));

                                    form.setFieldsValue({
                                        date: dayjs(record.date, "DD-MM-YYYY"),
                                        personnel: typeof record.personnel === "string"
                                            ? users.find(user => user.username === record.personnel)?._id || record.personnel
                                            : record.personnel,
                                        project: typeof record.project === "string"
                                            ? projects.find(project => project.projectName === record.project)?._id || record.project
                                            : record.project,
                                        description: record.description,
                                        attachments: processedAttachments,
                                    });

                                    setIsModalVisible(true);
                                }}
                                className="bg-green-500 text-white hover:bg-green-600"
                            />
                        </Tooltip>
                    )}

                    {(userRole === "admin") && (
                        <Tooltip title="Delete">
                            <Button
                                icon={<DeleteOutlined />}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setLogToDelete(record);
                                    setIsDeleteModalVisible(true);

                                }}
                                className="bg-red-500 text-white hover:bg-red-600"
                                disabled={deleteLoading}
                            />
                        </Tooltip>
                    )}

                    {(userRole === "admin") && (
                        <Tooltip title="Download PDF">
                            <Button
                                icon={<DownloadOutlined />}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    generatePDF(record);
                                }}
                                className="bg-blue-500 text-white hover:bg-blue-600"
                            />
                        </Tooltip>
                    )}
                </div>
            ),
        }
    ];

    return (
        <div className="flex flex-row">
            <Sidebar />
            <div className="w-full">
                <div className="p-8">
                    <div className="flex justify-between items-center mb-10">
                        <Input
                            prefix={<SearchOutlined className="text-gray-400" />}
                            placeholder="Search.."
                            className="w-[300px] h-[40px] rounded-[4px] shadow-sm bg-[#F6F6F6] "
                            onChange={(e) => handleFilterChange("keyword", e.target.value)}
                        />
                        <div className="flex flex-col justify-end h-full">
                            <p className="text-sm text-gray-500">Last refreshed {lastRefreshed}</p>
                        </div>
                    </div>

                    <div className="mb-8 flex justify-start">
                        <h2 className="text-[24px] font-semibold text-gray-800 mb-0">Daily Log</h2>

                    </div>
                    <div className="flex flex-wrap items-center gap-4 justify-start mb-6">
                        <div className="flex flex-col text-sm text-gray-600">
                            <label className="mb-1">Personnel</label>
                            <Select
                                placeholder="Select Personnel"
                                allowClear
                                onChange={(value) => handleFilterChange("personnel", value)}
                                className="w-[160px]"
                                size="middle"
                            >
                                {[...new Set(dailyLogs.flatMap(log => log.personnel))].map(personnel => (
                                    <Select.Option key={personnel} value={personnel}>
                                        {personnel}
                                    </Select.Option>
                                ))}
                            </Select>
                        </div>

                        <div className="flex flex-col text-sm text-gray-600">
                            <label className="mb-1">Project</label>
                            <Select
                                placeholder="Select Project"
                                allowClear
                                onChange={(value) => handleFilterChange("project", value)}
                                className="w-[160px]"
                                size="middle"
                            >
                                {[...new Set(dailyLogs.flatMap(log => log.project))].map(project => (
                                    <Select.Option key={project} value={project}>
                                        {project}
                                    </Select.Option>
                                ))}
                            </Select>
                        </div>

                        <div className="flex flex-col text-sm text-gray-600">
                            <label className="mb-1">Start Date</label>
                            <DatePicker
                                placeholder="Select Date"
                                onChange={(date) => handleFilterChange("startDate", date)}
                                format="DD-MM-YYYY"
                                className="w-[140px]"
                                size="middle"
                            />
                        </div>

                        <div className="flex flex-col text-sm text-gray-600">
                            <label className="mb-1">End Date</label>
                            <DatePicker
                                placeholder="Select Date"
                                onChange={(date) => handleFilterChange("endDate", date)}
                                format="DD-MM-YYYY"
                                className="w-[140px]"
                                size="middle"
                                disabledDate={(current) =>
                                    current && current.isBefore(filters.startDate, "day")
                                }
                            />
                        </div>

                        <div className="flex flex-col text-sm text-gray-600">
                            <label className="mb-1">Add Log</label>
                            <Button
                                icon={<span className="text-xl">＋</span>}
                                onClick={() => {
                                    setEditingLog(null);
                                    setIsModalVisible(true);
                                    form.resetFields();
                                    form.setFieldsValue({
                                        date: dayjs(),
                                        personnel: undefined,
                                        project: undefined,
                                        description: "",
                                        attachments: [],
                                    });
                                    setUploadedFiles(null);
                                }}
                                className="!border !border-gray-300 !text-[#0D2B52] hover:!text-orange-500 hover:!border-orange-500 transition-colors duration-200"
                            >
                                Add Daily Log
                            </Button>
                        </div>
                        <div className="flex flex-col text-sm text-gray-600">
                            <label className="mb-1">Download PDF</label>
                            <Button
                                className="!border !border-gray-300 !text-[#0D2B52] hover:!text-orange-500 hover:!border-orange-500 transition-colors duration-200"
                                icon={<i className="ri-download-2-line text-[16px]" />}
                                onClick={() => setIsModal(true)}
                            >
                                Download PDF
                            </Button>
                        </div>

                    </div>

                    <Table
                        dataSource={filteredLogs}
                        columns={columns}
                        rowKey="id"
                        className="mt-4 custom-table"
                        loading={loading}
                        rowClassName={() => "cursor-pointer hover:bg-gray-100 transition"}
                        onRow={(record) => ({
                            onClick: () => handleRowClick(record),
                        })}
                    />


                </div>
            </div>

            <Drawer
                open={isModalVisible}
                onClose={() => {
                    form.resetFields();
                    setIsModalVisible(false);
                    setEditingLog(null);
                    setUploadedFiles(null);
                }}
                placement="right"
                width={400}
                closable={false}
                title={
                    <div className="flex justify-between items-center">
                        <span className="text-xl font-semibold">Daily Log</span>
                        <CloseOutlined
                            className="text-lg cursor-pointer hover:text-red-500"
                            onClick={() => {
                                form.resetFields();
                                setIsModalVisible(false);
                                setEditingLog(null);
                                setUploadedFiles(null);
                            }}
                        />
                    </div>
                }
                footer={
                    <div className="text-center w-[100%] px-6 py-4  bg-white">
                        <Button
                            htmlType="submit"
                            form="dailyLogForm"
                            className="w-full !bg-[#0D2B52] hover:!bg-[#173E73] !text-white text-base h-10 rounded-[8px]"
                            loading={submitLoading}
                            disabled={submitLoading}
                        >
                            {editingLog ? "Update Log" : "Create Log"}
                        </Button>
                    </div>
                }
            >
                <Form
                    form={form}
                    id="dailyLogForm"
                    layout="vertical"
                    onFinish={editingLog ? handleEdit : handleSubmit}
                    initialValues={
                        editingLog
                            ? {
                                date: editingLog.date ? dayjs(editingLog.date, "DD-MM-YYYY") : dayjs(),
                                personnel: editingLog.personnel,
                                project: editingLog.project,
                                description: editingLog.description,
                                attachments: editingLog.attachments,
                            }
                            : {}
                    }
                >
                    <Form.Item
                        name="date"
                        label="Date"
                        required={false}
                        rules={[{ required: true, message: "Date is required!" }]}
                    >
                        <DatePicker className="w-full" format="DD-MM-YYYY" placeholder="DD-MM-YYYY" />
                    </Form.Item>

                    <Form.Item
                        name="personnel"
                        label="Personnel Working"
                        required={false}
                        rules={[{ required: true, message: "Please select personnel!" }]}
                    >
                        <Select
                            mode="tags"
                            placeholder="Select personnel"
                            optionLabelProp="label"
                            optionFilterProp="label"
                            allowClear
                            tokenSeparators={[","]}
                        >
                            {users.map((user) => (
                                <Option key={user._id} value={user.username} label={user.username}>
                                    {user.username}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="project"
                        label="Project"
                        required={false}
                        rules={[{ required: true, message: "Please select a project!" }]}
                    >
                        <Select
                            mode="multiple"
                            placeholder="Project name"
                            loading={loading}
                            disabled={loading || projects.length === 0}
                            notFoundContent={loading ? "Loading..." : "No Projects Available"}
                        >
                            {projects.map((project) => (
                                <Option key={project._id} value={project._id}>
                                    {project.projectName}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="description"
                        label="Log Description"
                        required={false}
                        rules={[{ required: true, message: "Please enter log details!" }]}
                    >
                        <TextArea
                            rows={4}
                            placeholder="Enter detailed log description"
                            className="resize-none"
                        />
                    </Form.Item>

                    <Form.Item name="attachments" label="Attachments (Optional)">
                        <Upload
                            multiple
                            beforeUpload={() => false}
                            listType="picture-card"
                            fileList={uploadedFiles}
                            onChange={handleFileChange}
                            onPreview={(file) => {
                                if (file.url || file.originFileObj) {
                                    window.open(file.url || URL.createObjectURL(file.originFileObj), "_blank");
                                }
                            }}
                            accept=".jpg,.jpeg,.png,.webp"
                        >
                            <div className="flex flex-col items-center text-blue-600">
                                <UploadOutlined className="text-2xl" />
                                <span>Upload</span>
                            </div>
                        </Upload>
                    </Form.Item>
                </Form>
            </Drawer>

            <Modal
                title="Confirm Delete"
                visible={isDeleteModalVisible}
                onCancel={() => setIsDeleteModalVisible(false)}
                footer={[
                    <Button key="cancel" onClick={() => setIsDeleteModalVisible(false)} disabled={deleteLoading}>
                        Cancel
                    </Button>,
                    <Button key="delete" type="primary" danger onClick={handleDelete} loading={deleteLoading}>
                        Delete
                    </Button>,
                ]}
            >
                <p>Are you sure you want to delete this log?</p>
            </Modal>

            <Modal
                title="View Daily Log"
                visible={isViewModalVisible}
                onCancel={() => setIsViewModalVisible(false)}
                footer={[
                    <Button key="close" onClick={() => setIsViewModalVisible(false)} className="bg-gray-500 text-white hover:bg-gray-600">
                        Close
                    </Button>
                ]}
            >
                <div className="p-4">
                    <Form layout="vertical">

                        <Form.Item label="Date">
                            <DatePicker
                                value={dayjs(viewingLog?.date, 'DD-MM-YYYY')}
                                format="DD-MM-YYYY"
                                disabled
                            />
                        </Form.Item>

                        <Form.Item label="Personnel">
                            <Input value={viewingLog?.personnel} disabled className="border-gray-300 rounded-md" />
                        </Form.Item>


                        <Form.Item label="Project">
                            <Input value={viewingLog?.project} disabled className="border-gray-300 rounded-md" />
                        </Form.Item>


                        <Form.Item label="Log Description">
                            <TextArea
                                value={viewingLog?.description}
                                rows={4}
                                disabled
                                className="border-gray-300 rounded-md"
                            />
                        </Form.Item>

                        <Form.Item label="Attachments">
                            {viewingLog?.attachments?.length > 0 ? (
                                <div className="space-y-4">
                                    {viewingLog.attachments.map((file, index) => (
                                        <div key={index} className="border p-2 rounded-lg bg-gray-100">
                                            <img
                                                src={file.imageUrl}
                                                alt={`attachment-${index}`}
                                                className="w-full max-h-60 object-contain rounded-md mb-2 cursor-pointer"
                                                onClick={() => window.open(`https://res.cloudinary.com/dz6v2e1p6/image/upload/${file.public_id}`, "_blank")}
                                            />
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="text-gray-500">No attachments available</div>
                            )}
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
            <Modal
                title="Select User to Download PDF"
                visible={isModal}
                onCancel={() => setIsModal(false)}
                footer={[
                    <Button key="cancel" onClick={() => setIsModal(false)}>
                        Cancel
                    </Button>,
                    <Button
                        key="download"
                        type="primary"
                        onClick={handleDownloadPDF}
                        disabled={!selectedUser}
                        loading={loading}
                    >
                        Download PDF
                    </Button>
                ]}
            >
                <Select
                    placeholder="Select a user"
                    style={{ width: "100%" }}
                    onChange={(value) => setSelectedUser(value)}
                >
                    {users.map((user) => (
                        <Select.Option key={user._id} value={user._id}>
                            {user.username}
                        </Select.Option>
                    ))}
                </Select>
            </Modal>
        </div>
    );
};

export default DailyLog;
